import { useStudioState } from '../state';

const useResetAllState = () => {
  const { resetState, resetFilterState } = useStudioState();

  const onResetAllState = () => {
    resetState();
    resetFilterState();
  };

  return onResetAllState;
};

export default useResetAllState;
